// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"749":"d5404b48","893":"94922ae8"}[chunkId] + ".chunk.css";
};